import axios from "axios";

const addressURL = `${process.env.REACT_APP_ADDRESS_URL_V2}/list`;

export const fetchAddressUnit = async (unitId, page = 1, limit = 20) => {
  try {
    if (!unitId) {
      const { data } = await axios.get(addressURL, {
        headers: { "X-Caller-Type": "internal" },
      });
      return { docs: data?.result?.docs ?? [], hasNextPage: false };
    }

    // id нь тоо болж ирэх тохиолдол бий — `.length` шалгалт дуугүй унахаас сэргийлнэ
    const id = String(unitId);

    let url;
    if (id.length === 2) {
      url = `${addressURL}?aimagId=${id}&page=${page}&limit=${limit}`;
    } else if (id.length === 4) {
      url = `${addressURL}?sumId=${id}&page=${page}&limit=${limit}`;
    } else {
      return { docs: [], hasNextPage: false };
    }

    const { data } = await axios.get(url, {
      headers: { "X-Caller-Type": "internal" },
    });
    return {
      docs: data?.result?.docs ?? [],
      hasNextPage: data?.result?.hasNextPage ?? false,
    };
  } catch (e) {
    console.error("Fetch Address Unit: ", e);
    return { docs: [], hasNextPage: false };
  }
};

export const formatAddressResponse = (result) => {
  const getAimagHot = (unit) => ({
    order: 100,
    type: "aimaghot",
    name: unit?._source?.name_full_mn ?? unit?._source?.name_mn,
    addressId: unit._id,
  });

  const getSumDuureg = (unit) => ({
    order: 200,
    type: "sumduureg",
    name: unit?._source?.name_mn,
    addressId: unit._id,
  });

  const getBagHoroo = (unit) => ({
    order: 300,
    type: "baghoroo",
    name: unit?._source?.name_short_mn,
    addressId: unit._id,
  });

  const fns = {
    2: getAimagHot,
    4: getSumDuureg,
    6: getBagHoroo,
  };

  return Array.isArray(result) && result.length > 0
    ? result.map((unit) => {
        let getter = fns[unit?._id?.length ?? 0];
        return typeof getter === "function" ? getter(unit) : unit;
      })
    : result ?? [];
};
